import React from 'react';
import classNames from "classnames";
import styles from "../../style/prediction.module.scss";

export const PredictionResultsBarItem = ({option, isFirst, isLast}) => {
  const itemProps = {
    className: classNames({[styles.results_bar_item]: !isLast && !isFirst},
      {[styles.results_bar_first_item]: !isLast && isFirst},
      {[styles.results_bar_last_item]: isLast && !isFirst},
      {[styles.results_bar_active_item]: option.isSelected}
    ),
    style: {
    animationDelay: `${option.delayMS}ms`,
      animationDuration: `${option.animationDuration}ms`,
      flex: option.vote.percentageValue
    }
  }

  return <div {...itemProps}/>
}
